import { render, staticRenderFns } from "./viewOrder.vue?vue&type=template&id=8cb87264&scoped=true&"
import script from "./viewOrder.vue?vue&type=script&lang=js&"
export * from "./viewOrder.vue?vue&type=script&lang=js&"
import style0 from "./viewOrder.vue?vue&type=style&index=0&id=8cb87264&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb87264",
  null
  
)

export default component.exports